import { Type } from "@shared/ui/Type";
import { ActionButtonsGroup } from "@shared/ui/ActionButtonsGroup";
import PanelTitle from "@shared/ui/PanelTitle";

export type Props = {
  onContinue: () => Promise<void>;
  onBack: () => void;
};

export function FriendInvitationSuccess({ onBack, onContinue }: Props) {
  return (
    <PanelTitle
      title="Your Friend Was Invited"
      description="An email was sent to your friend with an invitation to join Pollinator for free."
    >
      <Type variant="body1">
        And even if you don't invite a friend, we'll still place you in a great
        group of aligned peers. You can manage your invitation in Program &gt;
        Invites
      </Type>
      <ActionButtonsGroup
        onSecondaryClick={onBack}
        onPrimaryClick={onContinue}
        secondaryButtonText={"Back"}
        primaryButtonText={"Continue"}
      />
    </PanelTitle>
  );
}

export default FriendInvitationSuccess;
